import Formula from '@/assets/categories/formula.svg';
import TennisBall from '@/assets/categories/Tennis-Ball.svg';
import Golf from '@/assets/categories/Golf.svg';
import Soccer from '@/assets/categories/soccer.svg';
import MMA from '@/assets/categories/mma.svg';
import Basketball from '@/assets/categories/Basketball.svg';
import Esports from '@/assets/categories/esports.svg';
import NFL from '@/assets/categories/NFL.svg';
import Baseball from '@/assets/categories/baseball.svg';
import Cricket from '@/assets/categories/cricket.svg';
import BoxingGlove from '@/assets/categories/Boxing-Glove.svg';
import Hockey from '@/assets/categories/hockey.svg';
import Volleyball from '@/assets/categories/Volleyball.svg';
import Running from '@/assets/categories/Running.svg';
import Cycling from '@/assets/categories/Cycling.svg';
import IceSkating from '@/assets/categories/Ice-Skating.svg';
import Surfing from '@/assets/categories/Surfing.svg';
import SwimmingCap from '@/assets/categories/Swimming-Cap.svg';
import Pickleball from '@/assets/categories/Pickleball.svg';
import Badminton from '@/assets/categories/Badminton.svg';
import MLB from '@/assets/categories/MLB.svg';
import Legal from '@/assets/categories/Legal.svg';
import Lacrosse from '@/assets/categories/lacrosse.svg';
import {
	GameCategory,
	MarketStatus,
	TRADE_CREATED,
	MARKET_BULK_UPDATED,
	MARKET_DELETED,
	MARKET_UPDATED,
	EventType,
} from '@sportspredict/shared';

export const eventCategories = [
	{ id: '2512109b-2d5e-4ad2-a7eb-19129a49b319', name: 'Motorsports', icon: Formula },
	{ id: 'f1e2d3c4-b5a6-7890-1234-56789aacf0f0', name: 'Pickleball', icon: Pickleball },
	{ id: 'f1e2d3c4-b5a6-7890-1234-56789abcdef0', name: 'College Football', icon: NFL },
	{ id: 'b1e2c3d4-5f6a-7b8c-9d0e-1f2a3b4c5d6e', name: 'E-Sports', icon: Esports },
	{ id: 'c2d3e4f5-6a7b-8c9d-0e1f-2a3b4c5d6e7f', name: 'Tennis', icon: TennisBall },
	{ id: 'd3e4f5a6-7b8c-9d0e-1f2a-3b4c5d6e7f8a', name: 'Golf', icon: Golf },
	{ id: 'e4f5a6b7-8c9d-0e1f-2a3b-4c5d6e7f8a9b', name: 'Badminton', icon: Badminton },
	{ id: 'f5a6b7c8-9d0e-1f2a-3b4c-5d6e7f8a9b0c', name: 'Pro Basketball', icon: Basketball },
	{ id: 'a6b7c8d9-0e1f-2a3b-4c5d-6e7f8a9b0c1d', name: 'Soccer', icon: Soccer },
	{ id: 'b7c8d9e0-1f2a-3b4c-5d6e-7f8a9b0c1d2e', name: 'Pro MMA', icon: MMA },
	{ id: 'c8d9e0f1-2a3b-4c5d-6e7f-8a9b0c1d2e3f', name: 'Poker', icon: null },
	{ id: 'a2b3c4d5-e6f7-8901-2345-6789abcdef01', name: 'Pro Baseball', icon: MLB },
	{ id: 'f101aa12-bc34-4def-8123-123456789001', name: 'Pro Football', icon: NFL },
	{ id: 'f102bb23-cd45-5efa-9234-234567890012', name: 'Baseball', icon: Baseball },
	{ id: 'f103cc34-de56-6f0b-a345-345678901023', name: 'Cricket', icon: Cricket },
	{ id: 'f104dd45-ef67-701c-b456-456789012034', name: 'Boxing', icon: BoxingGlove },
	{ id: 'f105ee56-fa78-812d-c567-567890123045', name: 'MMA', icon: MMA },
	{ id: 'f106ff67-0b89-923e-d678-678901234056', name: 'Hockey', icon: Hockey },
	{ id: 'f107aa78-1c90-a34f-e789-789012345067', name: 'Volleyball', icon: Volleyball },
	{ id: 'f108bb89-2da1-b450-f890-890123456078', name: 'Track and Field', icon: Running },
	{ id: 'f109cc90-3eb2-c561-0890-901234567089', name: 'Swimming', icon: SwimmingCap },
	{ id: 'f110dd01-4fc3-d672-1901-012345678090', name: 'Cycling', icon: Cycling },
	{ id: 'f111ee12-5ad4-e783-2a12-123456789101', name: 'Ice Skating', icon: IceSkating },
	{ id: 'f112ff23-6be5-f894-3b23-234567891112', name: 'Surfing', icon: Surfing },
	{ id: 'f2b2d3c4-b5a6-7890-1234-56789abcdef1', name: 'Legal', icon: Legal },
	{ id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479', name: 'English Soccer', icon: Soccer },
	{ id: '9b1deb4d-3b7d-4c2f-8d2a-3a1f7c6e9b5f', name: 'Euro Soccer', icon: Soccer },
	{ id: '3fa85f64-5717-4b22-9e3e-1c6f8a9d7b2c', name: 'College Basketball', icon: Basketball },
	{ id: 'b4c5d6e7-f8a9-0b1c-2d3e-4f5a6b7c8d9e', name: 'Pro Hockey', icon: Hockey },
	{ id: 'a7c3f1d2-8e4b-4c9a-b6d1-2f5e8a7c9b3d', name: 'World soccer', icon: Soccer },
	{ id: 'b1d49993-7ce0-4770-8b4e-e9d083cc2370', name: 'Pro Lacrosse', icon: Lacrosse },
	{ id: 'c8e2b4f6-9a1d-4e7c-8b3f-2d5a9c6e7f4b', name: 'Pro Tennis Men', icon: TennisBall },
	{ id: 'e1f3a5b7-8c2d-4a9e-7f5b-1c4d8e6a2f9c', name: 'Pro Tennis Women', icon: TennisBall },
];

export const CATEGORY_MESSAGES = {
	'2512109b-2d5e-4ad2-a7eb-19129a49b319': 'Show us what you’ve got in four wheels. Good luck!',
	'f1e2d3c4-b5a6-7890-1234-56789aacf0f0':
		'Time to show off those fast hands. Let’s see your winning plays.',
	'f1e2d3c4-b5a6-7890-1234-56789abcdef0':
		'This is where upsets are born. Show us you can call the next big one.',
	'b1e2c3d4-5f6a-7b8c-9d0e-1f2a3b4c5d6e':
		'It’s not just about mechanics– it’s about the meta. Show us your game sense.',
	'c2d3e4f5-6a7b-8c9d-0e1f-2a3b4c5d6e7f':
		'It all comes down to match point. Can you handle the pressure?',
	'd3e4f5a6-7b8c-9d0e-1f2a-3b4c5d6e7f8a':
		'It’s just you against the course. Look out for the perfect shot.',
	'e4f5a6b7-8c9d-0e1f-2a3b-4c5d6e7f8a9b':
		'It’s the fastest racket sport on earth. Smash those markets!',
	'f5a6b7c8-9d0e-1f2a-3b4c-5d6e7f8a9b0c':
		'From tip-off to the final buzzer– show us you can win it all.',
	'a6b7c8d9-0e1f-2a3b-4c5d-6e7f8a9b0c1d':
		'Show your class on the pitch and build your Soccer rating',
	'b7c8d9e0-1f2a-3b4c-5d6e-7f8a9b0c1d2e':
		'Stand-up or ground game, every move matters. Call the finishing move.',
	'c8d9e0f1-2a3b-4c5d-6e7f-8a9b0c1d2e3f': 'Hold ‘em or fold ‘em. Read the room and go all in.',
	'a2b3c4d5-e6f7-8901-2345-6789abcdef01':
		'It ain’t over ‘til it’s over. Don’t just watch the pitch– call the home run!',
	'f101aa12-bc34-4def-8123-123456789001':
		'It’s all about the right playbook. Show us you can call the winning shots.',
	'f102bb23-cd45-5efa-9234-234567890012':
		'It ain’t over ‘til it’s over. Don’t just watch the pitch– call the home run!',
	'f103cc34-de56-6f0b-a345-345678901023':
		'Wickets, overs, and centuries. Read the pitch and hit for the win.',
	'f104dd45-ef67-701c-b456-456789012034':
		'Float like a butterfly, sting like a bee. Don’t pull your punches.',
	'f105ee56-fa78-812d-c567-567890123045':
		'Protect your picks at all times. Read the transition and call the submission.',
	'f106ff67-0b89-923e-d678-678901234056':
		'Skate to where the puck is going. Anticipate the play and call the next goal.',
	'f107aa78-1c90-a34f-e789-789012345067':
		'Read the set. Predict the spike and call the next point.',
	'f108bb89-2da1-b450-f890-890123456078':
		'Milliseconds matter. Analyze the field and predict the photo finish.',
	'f109cc90-3eb2-c561-0890-901234567089':
		'It’s a battle against drag. Predict the split and pick the winner at the wall.',
	'f110dd01-4fc3-d672-1901-012345678090':
		'Read the peloton. Predict the breakaway and call the stage winner.',
	'f111ee12-5ad4-e783-2a12-123456789101':
		'One slip changes everything. Judge the routine and predict the technical score.',
	'f112ff23-6be5-f894-3b23-234567891112':
		'Read the swell. Predict who finds the barrel, and who wipes out.',
	'f2b2d3c4-b5a6-7890-1234-56789abcdef1':
		'The evidence is in. It’s time to weigh the facts– let’s see your final verdict.',
	'f47ac10b-58cc-4372-a567-0e02b2c3d479':
		'Show your class on the pitch and build your Soccer rating',
	'9b1deb4d-3b7d-4c2f-8d2a-3a1f7c6e9b5f':
		'Show your class on the pitch and build your Soccer rating',
	'3fa85f64-5717-4b22-9e3e-1c6f8a9d7b2c':
		'From tip-off to the final buzzer– show us you can win it all.',
	'b4c5d6e7-f8a9-0b1c-2d3e-4f5a6b7c8d9e':
		'Drop the puck and call the play. Show us you can predict the ice.',
	'a7c3f1d2-8e4b-4c9a-b6d1-2f5e8a7c9b3d':
		'Show your class on the pitch and build your Soccer rating',
	'b1d49993-7ce0-4770-8b4e-e9d083cc2370': 'Keep pace with the fastest game on two feet. Good luck!',
	'c8e2b4f6-9a1d-4e7c-8b3f-2d5a9c6e7f4b':
		'Read the serve and call the winner from baseline to net.',
	'e1f3a5b7-8c2d-4a9e-7f5b-1c4d8e6a2f9c':
		'Read the serve and call the winner from baseline to net.',
};

export const hiddenEvents = ['2512109b-2d5e-4ad2-a7eb-19129a49b319'];

export const allowedValues = ['example.com', 'admin.com'];

export const allowedCategoriesForGameReq = Object.values(GameCategory);

export const INITIAL_NEW_MARKET = {
	question: '',
	initial_value: 50,
	status: MarketStatus.Queue,
	closing_date: '',
	opening_time: '',
};

export const INITIAL_EDIT_EVENT = {
	title: '',
	description: '',
	category_id: '',
	status: '',
	displayed_start_time: '',
	opening_time: '',
	end_date: '',
	closing_date: '',
	is_private: false,
	access_password: '',
	markets_open_time: '',
	has_multiple_lobbies: false,
	is_odds_locked: false,
	type: EventType.Binary,
};

export const INITIAL_TRADE_STAT = {
	total: 0,
	pending: 0,
	settled: 0,
};

export const REFETCH_TRADES_TAGS = [
	TRADE_CREATED,
	MARKET_UPDATED,
	MARKET_BULK_UPDATED,
	MARKET_DELETED,
];

export const TRADES_PAGE_SIZE = 25;

export const MARKETS_PAGE_SIZE = 30;

export const USER_HAS_TRADES_KEY = 'user_has_trades';
export const EventCompetitionType = 'pcl';

export const EVENT_TYPES = [
	{ value: EventType.Binary, label: 'Binary' },
	{ value: EventType.Probability, label: 'Probability' },
];
